import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PlatformAuthSurface } from "@/components/PlatformAuthSurface";
import { useAuth } from "@/lib/auth";
import { ROUTES, safeContinuePath } from "@/routes";

/**
 * Primary console login entry (Auth v2).
 * Uses private first-party platform auth — not Hosted portal transaction login.
 */
export function LoginPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, loading, setSession } = useAuth();
  const requested = new URLSearchParams(location.search).get("continue");
  const continueTo = safeContinuePath(requested, ROUTES.projects);

  useEffect(() => {
    if (!loading && user?.status === "active") {
      navigate(continueTo, { replace: true });
    }
  }, [user, loading, navigate, continueTo]);

  if (loading) {
    return (
      <main className="auth-page flex min-h-dvh items-center justify-center bg-background px-4">
        <p className="text-sm text-text-muted" role="status">
          Restoring session…
        </p>
      </main>
    );
  }

  if (user?.status === "active") {
    return null;
  }

  return (
    <main className="auth-page flex min-h-dvh items-center justify-center bg-background px-4 py-10">
      <PlatformAuthSurface
        defaultView="sign-in"
        onAuthenticated={(session) => {
          setSession(session);
          navigate(continueTo, { replace: true });
        }}
      />
    </main>
  );
}
